import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import {SearchFilterModule} from '../../components/search-filter/search-filter.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { TenantCustomImageDetailsRoutingModule } from './tenant-custom-image-details-routing.module';
import {TableModule} from 'src/app/table/table.module';
import { CommonTableModule } from 'src/app/components/table/table.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    BreadcrumbModule,
    TenantCustomImageDetailsRoutingModule,
    SearchFilterModule,
    PaginatorModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatCardModule,
    MatSelectModule,
    MatTabsModule,
    TableModule,
    CommonTableModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    MatIconModule,
    TranslocoModule,
    SidenavHeaderModule
  ]
})
export class TenantCustomImageDetailsModule { }